import { quickProperty, designToken } from '../component-tokens';
import { borderBase, inputFieldBase, inputFieldFocusBase, inputFieldHoverBase, largeInputFieldBase, smallInputFieldBase, xLargeInputFieldBase, } from './common';
import { sizeAttributes } from './utils';
export const selectTokens = {
    name: 'select',
    tag: 'chameleon-select',
    reactImports: 'Select',
    sizes: [
        {
            name: 'small',
            attributes: Object.assign({}, smallInputFieldBase),
        },
        {
            name: 'medium',
            attributes: {},
        },
        {
            name: 'large',
            attributes: Object.assign({}, largeInputFieldBase),
        },
        {
            name: 'xlarge',
            attributes: Object.assign({}, xLargeInputFieldBase),
        },
    ],
    attributes: Object.assign(Object.assign({}, inputFieldBase), { position: quickProperty('relative') }),
    variants: [
        {
            name: 'default',
            children: [
                {
                    name: 'icon',
                    tag: 'svg',
                    attributes: Object.assign(Object.assign({}, sizeAttributes('1rem')), { position: quickProperty('absolute'), top: quickProperty('0'), bottom: quickProperty('0'), margin: quickProperty('auto'), left: quickProperty('1rem'), 'z-index': quickProperty('2') }),
                },
                {
                    name: 'dropdown',
                    tag: 'select',
                    children: [
                        {
                            name: 'option1',
                            tag: 'option',
                        },
                    ],
                    attributes: Object.assign(Object.assign({}, borderBase), { 'border-radius': quickProperty('4px'), 'border-color': designToken('border'), cursor: quickProperty('pointer'), outline: quickProperty('none'), height: quickProperty('100%'), position: quickProperty('absolute'), padding: quickProperty('0 1rem 0 2.5rem'), width: quickProperty('100%'), '-moz-appearance': quickProperty('none'), '-webkit-appearance': quickProperty('none') }),
                    states: [
                        {
                            name: 'hover',
                            attributes: {
                                'border-color': designToken('field-02'),
                            },
                        },
                        {
                            name: 'focus',
                            attributes: {
                                'border-color': designToken('focus'),
                            },
                        },
                    ],
                },
                {
                    name: 'open',
                    tag: 'svg',
                    attributes: Object.assign(Object.assign({}, sizeAttributes('1rem')), { position: quickProperty('absolute'), top: quickProperty('0'), bottom: quickProperty('0'), margin: quickProperty('auto'), right: quickProperty('1rem'), 'z-index': quickProperty('2') }),
                },
            ],
            states: [
                {
                    name: 'hover',
                    attributes: Object.assign({}, inputFieldHoverBase),
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, inputFieldFocusBase),
                },
            ],
        },
    ],
};
